import styled from 'styled-components/macro'

const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-block-start: 1em;
`
export default LinkColumn
